const fields = (t) => ({
    config: { columns: 1 },
    fields: [
        {
            name: "unitCartonDimensions",
            label: t ? t("forms.unit_carton_dimensions") : "Wymiary kartonu jednostkowego (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "masterCartonDimensions",
            label: t ? t("forms.master_carton_dimensions") : "Wymiary kartonu zbiorczego (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "cartonsPerLayer",
            label: t ? t("forms.cartons_per_layer") : "Ilość kartoników w warstwie (poziom)",
            column: 1,
            type: "text"
        },
        {
            name: "layersPerPallet",
            label: t ? t("forms.layers_per_pallet") : "Ilość warstw w stercie",
            column: 1,
            type: "text"
        },
        {
            name: "palletsPerCarton",
            label: t ? t("forms.pallets_per_carton") : "Ilość stert w kartonie",
            column: 1,
            type: "text"
        }
    ]
});

export default fields;
